import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatConfirmationUtilityClass(slot) {
  return generateUtilityClass('MuiChatConfirmation', slot);
}
export const chatConfirmationClasses = generateUtilityClasses('MuiChatConfirmation', ['root', 'icon', 'message', 'actions', 'confirmButton', 'cancelButton']);
const slots = {
  root: ['root'],
  icon: ['icon'],
  message: ['message'],
  actions: ['actions'],
  confirmButton: ['confirmButton'],
  cancelButton: ['cancelButton']
};
export const useChatConfirmationUtilityClasses = classes => composeClasses(slots, getChatConfirmationUtilityClass, classes);